import Page from "../common/page/Page"
import style from "./Policies.module.css"

const Policies = () => {
  return (
    <Page title="Policies" searchDisabled={true}>
      <div className={style.policyContainer}>
        {/* Luxury Hero Banner */}
        <div className={style.heroHeader}>
          <h1>Store Policies & Terms</h1>
          <p className={style.heroSubtitle}>
            Complete legal documentation regarding your privacy, orders, shipping, and terms of service.
          </p>
        </div>

        {/* 1. Contact Us */}
        <div className={style.sectionCard}>
          <h2>Contact Us</h2>
          <p>
            For any questions, complaints, or support related queries, you can
            reach us at:
          </p>
          <ul>
            <li>
              <strong>Email:</strong>{" "}
              <a href="mailto:drmmherbalsenquiry@gmail.com">
                drmmherbalsenquiry@gmail.com
              </a>
            </li>
          </ul>
        </div>

        {/* 2. Privacy Policy */}
        <div className={style.sectionCard}>
          <h2>Privacy Policy</h2>

          <h3>SECTION 1 - WHAT DO WE DO WITH YOUR INFORMATION?</h3>
          <p>
            When you purchase something from our store, we collect the personal
            information you give us such as your name, address and email address.
            We also receive your computer’s IP address to help us learn about your
            browser and operating system.
          </p>
          <p>
            With your permission, we may send you emails about our store, new
            products, and other updates.
          </p>

          <h3>SECTION 2 - CONSENT</h3>
          <p>
            When you provide us with personal information to complete a
            transaction, place an order, arrange a delivery or return, we imply
            that you consent to our collecting it for that specific reason only.
          </p>
          <p>
            If we ask for your information for a secondary reason, like marketing,
            we will ask for your explicit consent or provide an opportunity to say
            no.
          </p>
          <p>
            To withdraw your consent, contact us at:{" "}
            <a href="mailto:drmmherbalsenquiry@gmail.com">
              drmmherbalsenquiry@gmail.com
            </a>
          </p>

          <h3>SECTION 3 - DISCLOSURE</h3>
          <p>
            We may disclose your personal information if required by law or if you
            violate our Terms of Service.
          </p>

          <h3>SECTION 4 - PAYMENT</h3>
          <p>
            We use Razorpay for processing payments. We/Razorpay do not store your
            card data on their servers. Data is encrypted via PCI-DSS standards
            during processing and is only retained as needed for your transaction.
          </p>
          <p>
            Razorpay complies with PCI-DSS standards managed by the PCI Security
            Standards Council (Visa, MasterCard, etc.). For more, visit:{" "}
            <a
              href="https://razorpay.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://razorpay.com
            </a>
          </p>

          <h3>SECTION 5 - THIRD-PARTY SERVICES</h3>
          <p>
            Third-party providers used by us only collect and use your information
            as needed to perform the services they provide. For example, payment
            processors may have their own privacy policies.
          </p>
          <p>
            If you proceed with a transaction involving a third-party, your
            information may become subject to their jurisdiction’s laws.
          </p>
          <p>
            Once you leave our site or are redirected to a third-party, you are no
            longer governed by our Privacy Policy or Terms.
          </p>
          <p>
            <strong>Links:</strong> Clicking links on our store may redirect you.
            We are not responsible for their privacy practices and encourage you
            to read their policies.
          </p>

          <h3>SECTION 6 - SECURITY</h3>
          <p>
            We take reasonable precautions and follow industry best practices to
            ensure your personal data is not lost, misused, accessed, disclosed,
            altered or destroyed.
          </p>

          <h3>SECTION 7 - COOKIES</h3>
          <p>
            We use cookies to maintain session state. These are not used to
            personally identify you on other websites.
          </p>

          <h3>SECTION 8 - AGE OF CONSENT</h3>
          <p>
            By using this site, you confirm you are at least the age of majority
            in your state or province, or have consented on behalf of your minor
            dependents.
          </p>

          <h3>SECTION 9 - CHANGES TO THIS PRIVACY POLICY</h3>
          <p>
            We may update this policy at any time. Changes take effect immediately
            upon posting. Material changes will be highlighted on this page.
          </p>

          <h3>QUESTIONS AND CONTACT INFORMATION</h3>
          <p>
            To access, correct, amend, or delete personal data we have about you,
            or for more information, contact our Privacy Compliance Officer at:{" "}
            <a href="mailto:drmmherbalsenquiry@gmail.com">
              drmmherbalsenquiry@gmail.com
            </a>
          </p>
        </div>

        {/* 4. Refund & Return Policy */}
        <div className={style.sectionCard}>
          <h2>Refund & Return Policy</h2>

          <h3>Returns</h3>
          <p>
            As our products come under health and personal care items, they are{" "}
            <strong>non-returnable</strong>. Please double-check your cart before
            placing an order.
          </p>

          <h3>Refunds (if applicable)</h3>
          <p>
            Refunds are only applicable for <strong>missing items</strong> inside
            the courier bag. A <strong>clear opening video</strong> is mandatory
            for verification.
          </p>
          <ul>
            <li>The video must be unedited, without cuts or pauses.</li>
            <li>
              Only genuine, unmodified videos are accepted. Edited or fake videos
              will not be considered.
            </li>
          </ul>
          <p>
            Once approved, the refund will be processed and credited to your
            original payment method within a few business days.
          </p>

          <h3>Late or Missing Refunds</h3>
          <p>If you haven't received your refund yet:</p>
          <ul>
            <li>Recheck your bank account or payment source.</li>
            <li>
              Contact your credit card company — it may take time before the
              refund is posted.
            </li>
            <li>Contact your bank — processing delays can occur.</li>
          </ul>
          <p>
            If you've done all of the above and still haven’t received your
            refund, please contact us at{" "}
            <a href="mailto:drmmherbalsenquiry@gmail.com">
              drmmherbalsenquiry@gmail.com
            </a>
            .
          </p>

          <h3>Sale Items</h3>
          <p>
            Only regular-priced items are eligible for refunds. Unfortunately,{" "}
            <strong>sale items cannot be refunded</strong>.
          </p>

          <h3>Exchanges (if applicable)</h3>
          <p>
            Exchanges are only accepted if you receive a{" "}
            <strong>wrong item</strong>. You must inform us within{" "}
            <strong>24 hours of delivery</strong>.
          </p>

          <h3>Shipping for Exchanges</h3>
          <p>
            Customers are responsible for paying their own shipping costs when
            returning an item for exchange. Shipping charges are non-refundable.
          </p>
          <p>
            Delivery time for exchanged products may vary depending on your
            location.
          </p>
        </div>

        {/* 5. Shipping Policy */}
        <div className={style.sectionCard}>
          <h2>Shipping Policy</h2>

          <p>
            All orders are processed within <strong>6 to 10 business days</strong>{" "}
            (excluding weekends and holidays) after you receive your order
            confirmation email.
          </p>
          <p>
            Delays may occur due to a high volume of orders or courier/postal
            service issues that are beyond our control.
          </p>
          <p>
            If you do not receive your product within{" "}
            <strong>4 days after the dispatch date</strong>, please inform us by
            emailing:{" "}
            <a href="mailto:drmmherbalsenquiry@gmail.com">
              drmmherbalsenquiry@gmail.com
            </a>
            .
          </p>

          <h3>Domestic Shipping Rates and Estimates</h3>
          <p>
            Shipping charges are automatically calculated and displayed during
            checkout based on your location.
          </p>
        </div>

        {/* 6. Terms of Service */}
        <div className={style.sectionCard}>
          <h2>Terms of Service</h2>

          <h3>Overview</h3>
          <p>
            This website is operated by Dr. Malu Mahendran’s. Throughout the site,
            the terms “we”, “us” and “our” refer to Dr. Malu Mahendran’s. By
            visiting our site and/or purchasing something from us, you agree to be
            bound by the following Terms and Conditions.
          </p>
          <p>
            These terms apply to all users of the site. Please read them
            carefully. If you do not agree, you may not access or use our website
            or services.
          </p>
          <p>
            We reserve the right to update or modify these terms at any time.
            Continued use of the site after such changes constitutes acceptance of
            the updated terms.
          </p>

          <h3>1. Online Store Terms</h3>
          <ul>
            <li>
              You must be at least the age of majority in your region or have
              permission from a guardian.
            </li>
            <li>
              You may not use our products for illegal or unauthorized purposes.
            </li>
            <li>
              Violation of any terms will result in immediate termination of
              services.
            </li>
          </ul>

          <h3>2. General Conditions</h3>
          <p>
            We reserve the right to refuse service. Your content (except credit
            card data) may be transferred unencrypted.
          </p>

          <h3>3. Accuracy, Completeness and Timeliness of Information</h3>
          <p>
            We are not responsible if information on this site is not accurate or
            current. It is your responsibility to monitor changes.
          </p>

          <h3>4. Modifications to the Service and Prices</h3>
          <p>
            Prices and services may change without notice. We are not liable for
            any service interruptions or changes.
          </p>

          <h3>5. Products or Services</h3>
          <p>
            Some products may be available exclusively online and subject to
            limited quantities. Product images and descriptions may vary.
          </p>

          <h3>6. Billing and Account Information</h3>
          <p>
            We may refuse or limit orders. You agree to provide current, complete
            and accurate billing and account info.
          </p>

          <h3>7. Optional Tools</h3>
          <p>
            We may offer access to third-party tools “as is”. Use of these tools
            is at your own risk.
          </p>

          <h3>8. Third-Party Links</h3>
          <p>
            We are not responsible for content or transactions with third-party
            websites linked from our site.
          </p>

          <h3>9. User Comments and Submissions</h3>
          <p>
            We may use your submissions freely. Comments must not violate rights
            or contain harmful content.
          </p>

          <h3>10. Personal Information</h3>
          <p>Submission of personal info is governed by our Privacy Policy.</p>

          <h3>11. Errors and Omissions</h3>
          <p>
            We reserve the right to correct errors or inaccuracies without prior
            notice.
          </p>

          <h3>12. Prohibited Uses</h3>
          <p>
            You are prohibited from using the site for unlawful or harmful
            purposes including harassment, data theft, or spreading malware.
          </p>

          <h3>13. Disclaimer of Warranties; Limitation of Liability</h3>
          <p>
            Use of the service is at your own risk. We are not liable for any
            damages arising from use of the site or services.
          </p>

          <h3>14. Indemnification</h3>
          <p>
            You agree to indemnify and hold us harmless from any third-party
            claims due to your breach of these terms.
          </p>

          <h3>15. Severability</h3>
          <p>
            If any part of these terms is found unenforceable, the rest remain
            valid.
          </p>

          <h3>16. Termination</h3>
          <p>
            These terms remain effective until terminated by either party. We may
            also terminate if you violate any provision.
          </p>

          <h3>17. Entire Agreement</h3>
          <p>
            These Terms constitute the full agreement between you and us regarding
            the Service.
          </p>

          <h3>18. Governing Law</h3>
          <p>
            These terms are governed by the laws of India and jurisdiction of
            Jaipur, Rajasthan.
          </p>

          <h3>19. Changes to Terms</h3>
          <p>
            We may update these terms at any time. Continued use of the site means
            you accept the new terms.
          </p>

          <h3>20. Contact</h3>
          <p>
            For questions, email us at{" "}
            <a href="mailto:drmmherbalsenquiry@gmail.com">
              drmmherbalsenquiry@gmail.com
            </a>
            .
          </p>
        </div>
      </div>
    </Page>
  )
}

export default Policies
